module.exports = __webpack_public_path__ + "img/logo4.d7399e6e.png";